import React, { RefObject, useEffect, useState } from 'react'
import ArrowButton from './Button/variations/ArrowButton'
import { Color, Direction } from '../utils/constants'
import { debounce } from '../utils/helpers'

interface ArrowNavigationProps {
  buttonColor?: Color
  scrollRef: RefObject<HTMLDivElement>
  children?: JSX.Element
  className?: string
}

const ArrowNavigation = ({ buttonColor, scrollRef, children, className }: ArrowNavigationProps) => {
    const [disabled, setDisabled] = useState({ left: true, right: false })

    useEffect(() => {
        const { current } = scrollRef
        const calculateDisabledButtons = debounce(() => {
            if (scrollRef.current) {
                setDisabled({
                    left: scrollRef.current?.scrollLeft <= 0,
                    right:
            scrollRef.current?.scrollLeft + scrollRef.current?.clientWidth >=
            scrollRef.current?.scrollWidth,
                })
            }
        }, 200)
        if (current) {
            current.addEventListener('scroll', calculateDisabledButtons)
        }
        return () => {
      current?.removeEventListener('scroll', calculateDisabledButtons)
        }
    }, [scrollRef])

    return (
        <div className='flex gap-x-4 items-center relative'>
            <ArrowButton
                direction={Direction.LEFT}
                onClick={() => scroll(Direction.LEFT, scrollRef)}
                disabled={disabled.left}
                buttonColor={buttonColor}
                className={className}
            />
            {children}
            <ArrowButton
                direction={Direction.RIGHT}
                onClick={() => scroll(Direction.RIGHT, scrollRef)}
                disabled={disabled.right}
                buttonColor={buttonColor}
                className={className}
            />
        </div>
    )
}

export const scroll = (value: Direction, scrollRef: RefObject<HTMLDivElement>) => {
    if (scrollRef.current) {
        const distance = scrollRef.current.children.item(0)?.clientWidth
        scrollRef.current.scrollLeft += (distance ?? 0) * (value === Direction.LEFT ? -1 : 1)
    }
}

export default ArrowNavigation
